// 心情指数（从积极到消极）+ 记录后的暖心回应，树洞与每日打卡弹窗共用
export const MOODS = [
  { key: '真开心', emoji: '😄', color: '#52c41a', reply: '真替你高兴，谢谢你愿意分享这份喜悦！愿好事连连 🎉' },
  { key: '愉快',   emoji: '🙂', color: '#73d13d', reply: '与你相处的每一天，都轻松愉快 🌤 继续保持好心情～' },
  { key: '平和',   emoji: '😌', color: '#40a9ff', reply: '平平淡淡才是真，愿你安稳自在，岁月温柔 🍵' },
  { key: '郁闷',   emoji: '😔', color: '#faad14', reply: '有什么不开心的？说出来，让我陪你一起分分忧 🤝' },
  { key: '伤心',   emoji: '😢', color: '#ff7a45', reply: '抱抱～伤心难免，但来日方长，一切都会慢慢向好的方向发展 🫂' },
  { key: '生气',   emoji: '😠', color: '#f5222d', reply: '生气最伤身啦，多想想开心的事，别跟自己过不去 🌿' },
];

export const MOOD_MAP = MOODS.reduce((m, x) => { m[x.key] = x; return m; }, {});

export const moodReply = (key) => (MOOD_MAP[key] && MOOD_MAP[key].reply) || '谢谢你记录下此刻的心情 🌱';
